import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

import Coupon from "../models/Coupon";
import Condition from "../models/Condition";
import Offer from "../models/Offer";
/**
 * 
 * @param {*} id 
 * 
 * Load tier will got data like this
 * {
 *   "data":
 *      {"id":"tier-606142f6f9a0d79dc76defd3",
 *       "name":"New","level":0,
 *       "conditions":[{"value":0,"condition_id":"cond-5172a0135d01a253b2b965ce"}],
 *       "privileges":[{
      "condition": {
        "value": 1000,
        "condition_id": "xxxxxx-5902ca0b0257bb14df426921"
      },
      "item": {
        "value": 10000,
        "coupon_id": "xxxxxx-5902ca0b0257bb14df426921"
      }
    }], 
 * "image_url":"https://bifrost.sandbox.wegiv.co/tier/new.png",...
 * Then load privileges info and condition
 * Currently API can't load getOne on coupons and condition so need to load all to check by itself
 * 
 * 
 * tier data example
 * [{ condition: {
              value: 100,
              message: "Buy more than %d units",
              id: "xxxx-12312313213",
              type: "[item_qty] >= [value]",
            },
            coupon: {
              value: 20,
              message: "Discount",
              id: "xxxx-12312313213",
              type: "Discount",
            }, 
          }]
 * 
 * @returns { tier, loading, error };
 */
export default function useOffersInfo() {
  const [offers, setOffers] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const data = await dataProvider.getList("offers", {
          addon: `{"authorize_pin":1}`,
          filter: { status: "Active" },
        });

        const result = data?.data?.map((offer) => {
          const offerInstance = new Offer({
            id: offer.id,
            name: offer.name,
            desc: offer.desc,
            pin: offer.authorize_pin,
            coupons: offer.items
              ? offer.items.map((item) => {
                  const coupon = new Coupon({
                    id: item.coupon_id,
                    value: item.value,
                    logic: item.coupon?.template.logic,
                    varName: item.coupon?.template.var_name,
                    type: item.coupon?.type,
                  });
                  return coupon;
                })
              : null,
            conditions: offer.conditions
              ? offer.conditions.map((condition) => {
                  const cond = new Condition({
                    id: condition.condition_id,
                    logic: condition.condition.template.logic,
                    value: condition.value,
                  });
                  return cond;
                })
              : null,
          });

          return offerInstance;
        });

        result.sort((first, second) => {
          if (first.coupons.length > 0 && second.coupons.length > 0)
            return first.coupons[0].value - second.coupons[0].value;
          else return 0;
        });

        setOffers(result);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isPassCondition = (template, item_qty, paid_amount, value) => {
    if (template === "[item_qty] >= [value]") {
      return item_qty >= value;
    } else if (template === "[paid_amount] >= [value]") {
      return paid_amount >= value;
    }
    return true;
  };

  return { offers, loading, error, isPassCondition };
}
